import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { requestApplicationManagerIdVerification } from '../api';

export default function useRequestApplicationManagerIdVerification(useMutationOptions) {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: () => dispatch(requestApplicationManagerIdVerification()),
    ...useMutationOptions,
  });
}
